export default {
    auth: {
        loggedIn: false,
    },
    notifications: [],
};
